import { __decorate } from "tslib";
import { Vue, Component } from 'vue-property-decorator';
import { createProvider } from '@/plugins/vue-apollo';
let AuthMixin = class AuthMixin extends Vue {
    authenticate(jwt, loginType) {
        this.$store.commit('session/authenticate', { token: jwt, loginType });
    }
    resetClient(jwt) {
        /**
         * Reinitialize Provider and Assign into Vue Instance
         * `$apolloProvider`
         */
        const client = createProvider(jwt).defaultClient;
        this.$apolloProvider.defaultClient = client;
    }
};
AuthMixin = __decorate([
    Component
], AuthMixin);
export default AuthMixin;
